import React, { useMemo, useEffect, Suspense, useState, useRef } from 'react'
import classes from './GroupsGrid.module.css'
import GroupCard from './GroupCard';
import Card from './Card';
import DataManager from '../../hooks/DataManager';
import DeviceLoadingGrid from '../../components/GridList/DeviceLoadingGrid';
import { Await, useNavigate } from 'react-router-dom';
import SearchBar from '../SearchView/Search/SearchBar';
import GroupsFilterDropdown from './GroupsFilterDropdown';
import BasicTable from '../../components/Table/Table/Table';
import Pill_Widget from '../../components/UI/Widgets/Pill_Widget';
import UseDateFormat from '../../components/hooks/UseDateFormat';
import DropdownList from '../../components/UI/Cards/DropdownList';
import AddUserIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/addUser.png'
import renameGroupIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/__Edit-93.svg'
import deleteGroupIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/deleteGroup.png'
import SettingsIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/settings.png'
import check from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/check.png'
import successAnim from '../../assets/animations/success.json'
import areYouSureAnim from '../../assets/animations/areYouSure.json'

import failAnim from '../../assets/animations/fail.json'
import ParentIndicator from './ParentIndicator';
import { useDispatch, useSelector } from 'react-redux';
import useClickOutside from '../../components/hooks/useClickOutside';
import Button1 from '../../components/UI/Button/Button1';
import FilterUsersSearch from '../../components/PowerSearch/FilterUsersSearch';
import { addUserToGroup, deleteGroup, renameGroup, editGroupDetails } from '../../Api Methods/Api';
import DropDownForm from '../../components/forms/DropdownCreateGroup';
import InputFormCreateGroup from '../../components/forms/InputFormCreateGroup';
import Modal from '../../components/Modal/Modal';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import Lottie from 'lottie-react';
import mixpanel from 'mixpanel-browser';

const GroupsGrid = ({GroupsList, setUpdate, update}) => {
    console.log(GroupsList);
    const dataManager = new DataManager();
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    // 0 = no filter, 1 = has, 2 = doesn't have
    const [booleanFilters, setBooleanFilters] = useState({
        allowSiteCreation: 0,
        allowGroupCreation: 0,
        billingEnabled: 0,
        supportEnabled: 0,
        isOnDD: 0,
        isWhitelabelCustomer: 0,
        isBillableAccount: 0,
    });
    const [openDropdownRowId, setOpenDropdownRowId] = useState(null);
    const [suggestions, setSuggestions] = useState([]);
    const dispatch = useDispatch();
    const [name, setName] = useState();
    const [selectionMade, setSelectionMade] = useState(false);
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const role = useSelector(state => state.auth.role);
    const companyName = useSelector(state => state.auth.companyName);
    const isEyeSpyFX = companyName === "EyeSpyFX";
    const apiData = {
        token,
        client
    }
    const [title, setTitle] = useState('');
    const [modalComponent, setModalComponent] = useState();
    const ModalDialog = useRef();
    const NotificationCounterRef = useRef("NotificationCounter");
    const buttonRef = useRef("DeviceCardSettingCog");
    const dropdownRef = useRef(null);
    const navigate = useNavigate();
    const [groupID, setGroupID] = useState();
    const [successVisible, setSuccessVisible] = useState(false)
    const [confirmVisible, setConfirmVisible] = useState(false)
    const [groupToDelete, setGroupToDelete] = useState()
    const [groupParent, setGroupParent] = useState("")

    const [selectedGroups, setSelectedGroups] = useState([])
    const [massPermissionsVisible, setMassPermissionsVisible] = useState(false)
    const [mEnableSupport, setMEnableSupport] = useState(false)
    const [mAllowSiteCreation, setMAllowSiteCreation] = useState(false)
    const [mBillingEnabled, setMBillingEnabled] = useState(false)
    const [mAllowGroupCreation, setMAllowGroupCreation] = useState(false)
    const [mAccountApproved, setMAccountApproved] = useState(false)
    const [mIsOnDD, setMIsOnDD] = useState(false)

    const HandleShowModal = () => {
        ModalDialog.current.open();
    };

    const HandleCloseModal = () => {
        ModalDialog.current.close();
        setName("")
        setSuggestions([])
        setSelectionMade(false);
    };

    const handleSettingsClick = (rowId) => {
        if (openDropdownRowId === rowId) {
            setOpenDropdownRowId(null);
        } else {
            setOpenDropdownRowId(rowId);
        }
    };

    useEffect(() => {
        const handleGroupsFilter = () => {
          const filtered = GroupsList.filter((item) =>
            Object.values(item)
              .some((value) => value?.toString().toLowerCase().includes(searchTerm.toLowerCase()))
          );
          dataManager.setItem('groupSearchTerm', searchTerm); // Store search term
          setFilteredData(filtered); // Update filtered data
        };
      
        if (searchTerm !== dataManager.getItem('groupSearchTerm')) {
            handleGroupsFilter(); // Call filtering function

            // timer for search tracking
            const timer = setTimeout(() => {
                mixpanel.track("Groups tab search performed", {
                    user: localStorage.getItem('email'),
                    searchTerm: searchTerm
                });
            }, 2000);
            return () => clearTimeout(timer);
        }

      }, [searchTerm]);


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                // Clicked outside the dropdown menu, so close it
                setOpenDropdownRowId(null);
            }
        };

        // Add event listener to listen for clicks outside the dropdown menu
        document.addEventListener('click', handleClickOutside);

        return () => {
        // Cleanup: Remove event listener when component unmounts
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);


    useEffect(() => {
        if (suggestions.length > 0 || selectionMade) {
            showAddUserModal();
        }
    }, [suggestions])

    useEffect(() => {
        if (name !== "" && name !== undefined){
            showAddUserModal();
        } 
    }, [name])

    const updateName = (name) => {
        setName(name);
        setSuggestions([]);
        dataManager.setItem('userToInvite', name);
        showAddUserModal();
        setSelectionMade(true);
    }

    const showAddUserModal = () => {
        setTitle("Add user")
        setModalComponent(
          <div>
            <div>
            <FilterUsersSearch searchQuery={name} setSearchQuery={setName} placeholder={"Enter users email address"} setIsLoading={false} setFilteredResults={setSuggestions} handleFilterLogic={handleFilterLogic} categories={["Online", "Offline", "Notifications On", "Notifications Off", "Favorited", "Not Favorited"]}></FilterUsersSearch>
            </div>
            {suggestions.length > 0 && (
              <ul
                  style={{
                      listStyle: 'none',
                      margin: 0,
                      padding: '8px',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      position: 'absolute',
                      width: '100%',
                      backgroundColor: '#fff',
                      zIndex: 1000,
                  }}>
  
                  {suggestions.map((suggestion, index) => (
                      <li
                          key={index}
                          onClick={() => updateName(suggestion)}
                          style={{
                              padding: '8px',
                              cursor: 'pointer',
                              borderBottom: '1px solid #ddd',
                          }}
                      >
                          {suggestion}
                      </li>
                  ))}
              </ul>
            )}     
            <br></br>
            <div style={{fontWeight: 300, fontStyle: 'italic'}}><p>Please note, users must have an existing mobile app account before being invited to a group.</p></div>
            <br></br>
            <div>
            </div>
            <br></br>
            <Button onClick={addUser} label="Add" severity='success' icon="pi pi-user-plus"/>
            
          </div>
        )  
        HandleShowModal();
    }

    const addUser = async () => {
        const email = name
        
        if (email != ''){

          let body = {
              groupID: groupID, 
              email: email, 
              role: "TechSupport", 
              owner: dataManager.getItem('isChecked') ? 1 : 0,
          }

          const response = await addUserToGroup(apiData, body, dispatch)
          if (response.success){
              dataManager.setItem('userToInvite', "");
              dataManager.setItem('isChecked', false);
              setUpdate(update+1);
              HandleCloseModal();
              setSuccessVisible(true)
          } else {
              //error
              showError(response);
          }
        }
    }

    // const showTransferGroupModal = () => {
    //     setTitle("Transfer group")
    //     const groupNames = groups.map(group => group.name);
    //     setModalComponent(
    //       <div>
    //         <div>
    //         <DropDownForm label={"Please select the new group below"} dropDownOptions={groupNames} setSelectedGroup={setSelectedGroup} />
    //       </div>
    //       <br></br>
    //         <Button1 onClick={transferGroup}>Transfer</Button1>
    //       </div>
    //     )  
    //     HandleShowModal();
    // }

    const showDeleteGroupModal = (groupID, parentName) => {
        setTitle("Delete group")
        setModalComponent(
          <div>
            <div style={{textAlign: "center"}}>
              <h2>Are you sure you want to delete this group?</h2>
              <h3 style={{textAlign:"center"}}>This action cannot be undone!</h3>
            </div>
            <br></br>
            <div>
              <p style={{fontStyle: 'italic', textAlign:"center"}}>{`All sites within this group will be moved to ${parentName}`}</p>
            </div>
            <br></br>
            <div style={{ 
                  display: "flex", 
                  flexDirection: "column", 
                  alignItems: "center", 
                  gap: "10px" // Adds space between buttons
                }}>
              <Button  icon="pi pi-times" onClick={HandleCloseModal} label="No, cancel" severity='secondary'/>              
              <Button  icon="pi pi-check" onClick={() => deleteGroupAPI(groupID)} label="Yes, I'm sure" severity='danger'/>
              
            </div>
          </div>
        ) 
  
        HandleShowModal();
    }

    const deleteGroupAPI = async (groupID) => {
        const response = await deleteGroup(apiData, groupID, dispatch)
        if (response.success){
        //refresh
            setUpdate(update+1);
            HandleCloseModal();
            //successModal();
            setSuccessVisible(true)
            setConfirmVisible(false)
        } else {
            showError(response);
        }
    }

    const showError = (response) => {
        setTitle("Error")
        setModalComponent(
          <div>
          <div>
            <h3 style={{textAlign: "center"}}>Error</h3>
          </div>     
          <div>
            <p style={{textAlign: "center"}}>{response.msg}</p>
          </div> 
          <div style={{ 
                  display: "flex", 
                  flexDirection: "column", 
                  alignItems: "center", 
                  gap: "10px" // Adds space between buttons
                }}>
          <Button  icon="pi pi-times" onClick={HandleCloseModal} label="Close" severity='secondary'/>
          </div>
        </div>
        ) 
  
        HandleShowModal();
    }

    const showRenameGroupModal = (groupID, groupName) => {
        setTitle("Rename group")
        setModalComponent(
          <div>
          <div>
            <InputFormCreateGroup label={"Enter new group name"} setName={setName}></InputFormCreateGroup>
          </div>     
          <br></br>
          <Button  icon="pi pi-check" onClick={() => RenameGroup(groupID, groupName)} label="Rename" severity='success'/>
          
        </div>
        ) 
  
        HandleShowModal();
    }

    const RenameGroup = async (groupID, groupName) => {
        const newName = dataManager.getItem('groupName');
        const oldName = groupName;
        let body = {
            groupID: groupID, 
            oldName: oldName, 
            newName: newName
        };

        const response = await renameGroup(apiData, body, dispatch)
        if (response){
            setUpdate(update+1);
            HandleCloseModal();
            //successModal();
            setSuccessVisible(true)
        } else {
            //error
        }
    }

    const UserActionHandler = (userAction, groupID, parentName, groupName, group) => {
        setGroupID(groupID)
        switch (userAction){
         case 'Add user': 
           showAddUserModal();
         break;
         case 'Delete group':
           //dataManager.setItem('groupClickedID', groupID);
           setConfirmVisible(true)
           setGroupToDelete(group)
           setGroupParent(parentName)
           //showDeleteGroupModal(groupID, parentName);
         break;
         case 'Rename group':
           sessionStorage.setItem('groupClickedID', groupID);
           showRenameGroupModal(groupID, groupName);
         break;
        }
    }

    // const successModal = () => {
    //   setTitle('Success')
    //   setModalComponent(
    //     <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
    //       <img className={classes.ModalIcon} src={check}>
    //       </img>
    //       <br></br>
    //       <br></br>
    //       <div>
    //           <h3 style={{ textAlign: "center", color:"#858585"}}>Action completed successfully</h3>
    //       </div>   
    //       <br></br>
    //       <br></br>
    //       <div>
    //         <br></br>
    //         <Button1 onClick={HandleCloseModal} style={{width:"100%"}}>Close</Button1>
    //       </div>
    //     </div>
    //   )
    //   HandleShowModal();
    // }

    const saveMassPermissions = async () => {
        const fields = [
            { column: "supportEnabled",    value: mEnableSupport      ? 1 : 0 },
            { column: "allowSiteCreation", value: mAllowSiteCreation  ? 1 : 0 },
            { column: "billingEnabled",    value: mBillingEnabled     ? 1 : 0 },
            { column: "allowGroupCreation",value: mAllowGroupCreation ? 1 : 0 },
            { column: "accountApproved",   value: mAccountApproved    ? 1 : 0 },
            { column: "isOnDD",            value: mIsOnDD             ? 1 : 0 },
        ]
        const calls = selectedGroups.flatMap(group =>
            fields.map(({ column, value }) =>
                editGroupDetails(apiData, { groupID: group.id, columnName: column, newValue: value }, dispatch)
            )
        )
        const results = await Promise.all(calls)
        setMassPermissionsVisible(false)
        setSelectedGroups([])
        if (results.every(r => r.success)) {
            setSuccessVisible(true)
        }
        setUpdate(update + 1)
    }

    const handleFilterLogic = async (data, searchQuery, selectedCategories) => {
        const users = await data;
        const usersEmails = users.map(user => user.email);
        setSuggestions(usersEmails);
    };

    const handleGroupClicked = (groupName, groupID, groupPath) => {
        // dataManager.setItem('groupClicked', groupName)   
        // dataManager.setItem('groupPath', groupPath)
        // dataManager.setItem('groupClickedID', groupID)  
        
        sessionStorage.setItem("groupClicked", groupName)
        sessionStorage.setItem("groupPath", groupPath)
        sessionStorage.setItem("groupClickedID", groupID)


        navigate("/Dashboard/Groups/GroupSites")
    }

    const toggleSelectGroup = (group) => {
        setSelectedGroups(prev =>
            prev.some(g => g.id === group.id) ? prev.filter(g => g.id !== group.id) : [...prev, group]
        )
    }

    const selectColumn = {
            id: 'select',
            filterLabel: "Select",
            header: ({ table }) => {
                const allRows = table.getRowModel().rows.map(r => r.original)
                const allSelected = allRows.length > 0 && allRows.every(g => selectedGroups.some(s => s.id === g.id))
                return (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Checkbox
                            checked={allSelected}
                            onChange={e => {
                                if (e.checked) setSelectedGroups(prev => {
                                    const toAdd = allRows.filter(g => !prev.some(s => s.id === g.id))
                                    return [...prev, ...toAdd]
                                })
                                else setSelectedGroups(prev => prev.filter(g => !allRows.some(r => r.id === g.id)))
                            }}
                        />
                    </div>
                )
            },
            cell: (row) => (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Checkbox
                        checked={selectedGroups.some(g => g.id === row.row.original.id)}
                        onChange={() => toggleSelectGroup(row.row.original)}
                    />
                </div>
            )
        }

    let tableColumns = [
        ...(isEyeSpyFX ? [selectColumn] : []),
        {
            id: 'groupName',
            header: () => (
              <div className={classes.tableTitleText} title="Click to sort">
                <h3>Group name</h3>
              </div>
            ),
            filterLabel: "Group name",
            accessorKey: 'name',
            cell: (row) => {
              const name = row.row.original.name;
              return (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div onClick={() => handleGroupClicked(row.row.original.name, row.row.original.id, row.row.original.group_path)} style={{ cursor: "pointer", width: "fit-content" }}>
                    {row.row.original.name && row.row.original.name.trim() !== "" && (
                      <Pill_Widget
                        boolean={true}
                        PillColor_IfTrue={"#9a9a9a"}
                        PillColor_IfFalse={"#9a9a9a"}
                        text_IfTrue={row.row.original.name}
                        className={classes.PillHeight}
                      />
                    )}
                  </div>
                </div>
              );
            }, 
        },
        {
            id: 'parentName',
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                <h3>Group parent</h3>
            </div>
            ),
            filterLabel: "Parent group name",
            accessorKey: 'parent_name',
            cell: (row) => {
                return (
                <div onClick={() => handleGroupClicked(row.row.original.name, row.row.original.id, row.row.original.group_path)} className={classes.tableValueText}>
                    {row.row.original.parent_name && row.row.original.parent_name.trim() !== "" && (
                        <ParentIndicator companyName={row.row.original.parent_name}/>
                    )}
                </div>
                )
            }
        },
        {
            id: 'key',
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                <h3>Number of sites</h3>
                </div>
            ),
            filterLabel: "Site count",
            accessorKey: 'siteCount',
            cell: (row) => {
        
                return (
                <div onClick={() => handleGroupClicked(row.row.original.name, row.row.original.id, row.row.original.group_path)} className={classes.tableValueTextBold}>
                    {row.row.original.deviceCount}
                </div>
                )
            }
        },
        {
            id: 'userCount',
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                <h3>Number of portal users </h3>
                </div>
            ),
            filterLabel: "User count",
            accessorKey: 'userCount',
            cell: (row) => {
                return (
                    <div onClick={() => handleGroupClicked(row.row.original.name, row.row.original.id, row.row.original.group_path)} className={classes.tableValueTextBold}>
                        {row.row.original.userCount}
                    </div>
                )
            } 
        }, 
        {
            id: 'customerNumber',
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Customer number</h3>
                </div>
            ),
            filterLabel: "Customer number",
            accessorKey: 'customerNumber',
            cell: (row) => (
                <div className={classes.tableValueText}>
                    {row.row.original.customerNumber}
                </div>
            )
        },
        {
            id: 'billingType',
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Billing type</h3>
                </div>
            ),
            filterLabel: "Billing type",
            accessorKey: 'billingType',
            cell: (row) => (
                <div className={classes.tableValueText}>
                    {row.row.original.billingType}
                </div>
            )
        },
        {
            id: 'allowSiteCreation',
            header: () => (
                <div className={classes.tableTitleText} style={{ textAlign: 'center' }} title="Click to sort">
                    <h3>Site creation</h3>
                </div>
            ),
            filterLabel: "Allow site creation",
            accessorKey: 'allowSiteCreation',
            cell: (row) => (
                <div className={classes.tableValueText} style={{ textAlign: 'center' }}>
                    {row.row.original.allowSiteCreation ? <img src={check} alt="Yes" style={{ width: 25, height: 25, display: 'block', margin: '0 0 0 0' }} /> : null}
                </div>
            )
        },
        {
            id: 'allowGroupCreation',
            header: () => (
                <div className={classes.tableTitleText} style={{ textAlign: 'center' }} title="Click to sort">
                    <h3>Group creation</h3>
                </div>
            ),
            filterLabel: "Allow group creation",
            accessorKey: 'allowGroupCreation',
            cell: (row) => (
                <div className={classes.tableValueText} style={{ textAlign: 'center' }}>
                    {row.row.original.allowGroupCreation ? <img src={check} alt="Yes" style={{  width: 25, height: 25, display: 'block', margin: '0 auto' }} /> : null}
                </div>
            )
        },
        {
            id: 'billingEnabled',
            header: () => (
                <div className={classes.tableTitleText} style={{ textAlign: 'center' }} title="Click to sort">
                    <h3>Billing</h3>
                </div>
            ),
            filterLabel: "Billing enabled",
            accessorKey: 'billingEnabled',
            cell: (row) => (
                <div className={classes.tableValueText} style={{ textAlign: 'center' }}>
                    {row.row.original.billingEnabled ? <img src={check} alt="Yes" style={{  width: 25, height: 25, display: 'block', margin: '0 auto' }} /> : null}
                </div>
            )
        },
        {
            id: 'supportEnabled',
            header: () => (
                <div className={classes.tableTitleText} style={{ textAlign: 'center' }} title="Click to sort">
                    <h3>Support</h3>
                </div>
            ),
            filterLabel: "Support enabled",
            accessorKey: 'supportEnabled',
            cell: (row) => (
                <div className={classes.tableValueText} style={{ textAlign: 'center' }}>
                    {row.row.original.supportEnabled ? <img src={check} alt="Yes" style={{  width: 25, height: 25, display: 'block', margin: '0 auto' }} /> : null}
                </div>
            )
        },
        {
            id: 'isOnDD',
            header: () => (
                <div className={classes.tableTitleText} style={{ textAlign: 'center' }} title="Click to sort">
                    <h3>Direct Debit</h3>
                </div>
            ),
            filterLabel: "Is on direct debit",
            accessorKey: 'isOnDD',
            cell: (row) => (
                <div className={classes.tableValueText} style={{ textAlign: 'center' }}>
                    {row.row.original.isOnDD ? <img src={check} alt="Yes" style={{ width: 25, height: 25, display: 'block', margin: '0 auto' }} /> : null}
                </div>
            )
        },
        {
            id: 'isWhitelabelCustomer',
            header: () => (
                <div className={classes.tableTitleText} style={{ textAlign: 'center' }} title="Click to sort">
                    <h3>Whitelabel customer</h3>
                </div>
            ),
            filterLabel: "Is whitelabel customer",
            accessorKey: 'isWhitelabelCustomer',
            cell: (row) => (
                <div className={classes.tableValueText} style={{ textAlign: 'center' }}>
                    {row.row.original.isWhitelabelCustomer ? <img src={check} alt="Yes" style={{ width: 25, height: 25, display: 'block', margin: '0 auto' }} /> : null}
                </div>
            )
        },
        {
            id: 'isBillableAccount',
            header: () => (
                <div className={classes.tableTitleText} style={{ textAlign: 'center' }} title="Click to sort">
                    <h3>Billable account</h3>
                </div>
            ),
            filterLabel: "Is billable account",
            accessorKey: 'isBillableAccount',
            cell: (row) => (
                <div className={classes.tableValueText} style={{ textAlign: 'center' }}>
                    {row.row.original.isBillableAccount ? <img src={check} alt="Yes" style={{ width: 25, height: 25, display: 'block', margin: '0 auto' }} /> : null}
                </div>
            )
        },
    ];

    const myCompanyGroup = GroupsList?.find(g => g.name === companyName);

    if (!isEyeSpyFX) {
        tableColumns = tableColumns.filter(col => !['billingType', 'billingEnabled', 'isOnDD', 'customerNumber', 'isWhitelabelCustomer', 'isBillableAccount'].includes(col.id));
        if (!myCompanyGroup?.allowSiteCreation)  tableColumns = tableColumns.filter(col => col.id !== 'allowSiteCreation');
        if (!myCompanyGroup?.allowGroupCreation) tableColumns = tableColumns.filter(col => col.id !== 'allowGroupCreation');
        if (!myCompanyGroup?.supportEnabled)     tableColumns = tableColumns.filter(col => col.id !== 'supportEnabled');
    }

    // Only offer "has/doesn't have" filters for the boolean columns that are actually visible above
    const BOOLEAN_FIELD_LABELS = {
        allowSiteCreation: 'Site creation',
        allowGroupCreation: 'Group creation',
        billingEnabled: 'Billing',
        isWhitelabelCustomer: 'Whitelabel customer',
        isBillableAccount: 'Billable account',
        supportEnabled: 'Support',
        isOnDD: 'Direct Debit',
    };
    const filterableFields = Object.keys(BOOLEAN_FIELD_LABELS)
        .filter(key => tableColumns.some(col => col.id === key))
        .map(key => ({ key, label: BOOLEAN_FIELD_LABELS[key] }));

    tableColumns = [...tableColumns, {
            id: 'groupSettings',
            filterLabel: "groupSettings",
            cell: (row) => {
                let items = [
                    {
                        image: AddUserIcon,
                        title: "Add user"
                    },
                    // {
                    //     image: renameGroupIcon,
                    //     title: "Rename group"
                    // },
                    ...(role === "admin" ? [{
                        image: deleteGroupIcon,
                        title: "Delete group"
                    }] : [])
                ];
                
                const ifSettingsCogIsClicked = openDropdownRowId === row.row.id
                if (role !== "admin" && role !== "TechSupport") return null;
                return <DropdownList
                    item={row.row.id}
                    icon={SettingsIcon}
                    onClick={handleSettingsClick}
                    ifSettingsCogIsClicked={ifSettingsCogIsClicked}
                    ref={dropdownRef}
                    title={"Actions"}
                    className={classes.container}
                    onUserActionClick={(userAction) => UserActionHandler(userAction, row.row.original.id, row.row.original.parent_name, row.row.original.name, row.row.original)}
                    listItems={items}
                />
            }
        }];

    return (
      <>
     <Dialog
            header="Success"
            visible={successVisible}
            style={{ width: "40vw" }}
            onHide={() => setSuccessVisible(false)}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <h3 style={{color:"#6e6e6eff"}}>Action completed successfully!.</h3>
                <Lottie
                    animationData={successAnim}
                    loop={false}
                    style={{ width: 250, height: 250, margin: "0px" }}
                />

                <Button label="Close" icon="pi pi-times" rounded severity="primary" onClick={() => setSuccessVisible(false)}/>
            </div>
        </Dialog>

        <Dialog
            header="Are you sure?"
            visible={confirmVisible}
            style={{ width: "40vw" }}
            onHide={() => setConfirmVisible(false)}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                <Lottie
                    animationData={areYouSureAnim}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
            <br/>
            <h3 style={{color:"#6e6e6eff"}}>{`Are you sure you want to delete ${groupToDelete?.name}`}</h3>
            <p style={{fontStyle: 'italic', textAlign:"center"}}>{`All sites within this group will be moved to ${groupParent}`}</p>

            <p>This is a PERMANENT action and cannot be undone!</p>
                <br/>
                <Button label="No cancel" rounded icon="pi pi-times" severity="secondary" onClick={() => setConfirmVisible(false)}/>
                <br/>
                <Button label="Yes, delete group" rounded icon="pi pi-check" severity="danger" onClick={() => { deleteGroupAPI(groupToDelete.id) }}/>

            </div>
        </Dialog>


        <Dialog
            header={`Set permissions — ${selectedGroups.length} group${selectedGroups.length !== 1 ? 's' : ''} selected`}
            visible={massPermissionsVisible}
            style={{ width: "420px" }}
            onHide={() => setMassPermissionsVisible(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                {[
                    { id: "mEnableSupport",      label: "Enable Inniovate ticket creation",        checked: mEnableSupport,      set: setMEnableSupport },
                    { id: "mAllowSiteCreation",  label: "Allow site creation",   checked: mAllowSiteCreation,  set: setMAllowSiteCreation },
                    { id: "mBillingEnabled",     label: "Enable billing",        checked: mBillingEnabled,     set: setMBillingEnabled },
                    { id: "mAllowGroupCreation", label: "Allow group creation",  checked: mAllowGroupCreation, set: setMAllowGroupCreation },
                    { id: "mAccountApproved",    label: "Account approved",      checked: mAccountApproved,    set: setMAccountApproved },
                    { id: "mIsOnDD",             label: "Is on Direct Debit",    checked: mIsOnDD,             set: setMIsOnDD },
                ].map(({ id, label, checked, set }) => (
                    <div key={id} style={{ display: "flex", alignItems: "center", gap: "12px", cursor: "pointer" }}>
                        <Checkbox inputId={id} checked={checked} onChange={e => set(e.checked)} />
                        <label htmlFor={id} style={{ fontSize: "14px", color: "#4a4a4a", cursor: "pointer", userSelect: "none" }}>{label}</label>
                    </div>
                ))}
                <p style={{ fontSize: "12px", color: "#9a9a9a", margin: 0 }}>
                    All selected groups will be set to these exact values on save.
                </p>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", borderTop: "1px solid #f0f0f0", paddingTop: "16px" }}>
                    <Button label="Cancel" icon="pi pi-times" severity="secondary" onClick={() => setMassPermissionsVisible(false)} />
                    <Button label="Save" icon="pi pi-save" onClick={saveMassPermissions} />
                </div>
            </div>
        </Dialog>

        <div className={`${classes.table} ${classes.center} `}>
          <div className={classes["tableCardLayoutUI-wrapper"]}>
            <div className={classes["top-wrapper"]}>
            </div>
            <Suspense fallback={
               <div style={{ display: "flex", width: "100%" }}>
                  <DeviceLoadingGrid
                    CardCount={20}
                  />
                </div>
            }>
  
              <Await resolve={GroupsList}>
                {(loadedtableData) => {
                    const filteredData = loadedtableData.filter((item) => {
                      // Adjust this condition based on the properties you want to search
                      const matchesSearch = Object.values(item)
                          .some(value => value?.toString().toLowerCase().includes(searchTerm.toLowerCase()));
                      if (!matchesSearch) return false;

                      return Object.entries(booleanFilters).every(([field, mode]) => {
                          if (mode === 0) return true;
                          const hasValue = Boolean(item[field]);
                          return mode === 1 ? hasValue : !hasValue;
                      });
                  });
                  return (
                    <>
                    <Modal ref={ModalDialog} title={title} modalName={""} HandleShowModal={HandleShowModal}>
                        {modalComponent}
                    </Modal>

                     <div className={classes.searchContainer} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <SearchBar
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        {filterableFields.length > 0 && (
                            <GroupsFilterDropdown
                                fields={filterableFields}
                                filters={booleanFilters}
                                onApply={setBooleanFilters}
                            />
                        )}
                      </div>

                      <p style={{marginLeft:"15px", marginBottom:"20px"}}>Total results: {filteredData.length}</p>

                      {isEyeSpyFX && selectedGroups.length > 0 && (
                          <div style={{ display: "flex", alignItems: "center", gap: "12px", padding: "10px 15px", marginBottom: "8px", background: "#f5f5f5", borderRadius: "6px", border: "1px solid #e0e0e0" }}>
                              <span style={{ fontSize: "14px", color: "#4a4a4a", fontWeight: 500 }}>{selectedGroups.length} group{selectedGroups.length !== 1 ? 's' : ''} selected</span>
                              <Button
                                  label="Set permissions"
                                  icon="pi pi-cog"
                                  severity="secondary"
                                  size="small"
                                  onClick={() => {
                                      const consensus = (key) => selectedGroups.every(g => !!g[key]) ? true : selectedGroups.every(g => !g[key]) ? false : false;
                                      setMEnableSupport(consensus('supportEnabled'))
                                      setMAllowSiteCreation(consensus('allowSiteCreation'))
                                      setMBillingEnabled(consensus('billingEnabled'))
                                      setMAllowGroupCreation(consensus('allowGroupCreation'))
                                      setMAccountApproved(consensus('accountApproved'))
                                      setMIsOnDD(consensus('isOnDD'))
                                      setMassPermissionsVisible(true)
                                  }}
                              />
                              <Button label="Clear selection" icon="pi pi-times" severity="secondary" size="small" text onClick={() => setSelectedGroups([])} />
                          </div>
                      )}

                  <BasicTable data={filteredData} columns={tableColumns} filtering={""} rowClick={false} ShowPagination={false} PageSize={500} paginationOptions={[25, 50, 100]} showFilterButton={true} HandleTableFiltering={""} />
                </>
            )}}
            </Await>
            </Suspense>
        </div>
      </div>


        </>
       
    )
}

export default GroupsGrid